export default "__VITE_ASSET__3e9b499f__"